import { render, staticRenderFns } from "./SimilarHotel.vue?vue&type=template&id=5b27a018"
import script from "./SimilarHotel.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimilarHotel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SimilarHotel.vue?vue&type=style&index=0&id=5b27a018&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports